export default __webpack_public_path__ + "static/media/MailIcon.786656db.svg";